export const list = {
  table: {
    title: 'Machine parts',
    id: 'ID',
    name: 'Name',
    totalTimeUsed: 'Total Time Used',
    totalLife: 'Total Life',
    usedTime: 'Used Time',
    timeLeftToChange: 'Time left to change',
    changedDate: 'Changed Date',
    complete: 'Complete',
    detail: 'Detail',
    unit: 'times',
    success: 'Successful component replacement',
    error: 'Failed component replacement',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Failed to delete',
  },
  recentHistory: {
    title: 'Recent history',
    id: 'ID',
    name: 'Name',
    usedTime: 'Used Time',
    changedDate: 'Changed Date',
  },
  modal: {
    id: 'ID',
    usedTime: 'Used Time',
    changedDate: 'Changed Date',
    title: 'Machine Component Details',
  },
  pageHeader: {
    title: 'Machine component management',
    titleMachinePartsList: 'Personal data registration/editing',
    new: 'New',
  },
}
